import { render, staticRenderFns } from "./SelectionValues.vue?vue&type=template&id=3f996ee9"
import script from "./SelectionValues.vue?vue&type=script&lang=js"
export * from "./SelectionValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports